import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { updateCurrentPath } from "../../../../store/actions/root.actions";
import BaseButton from "../../Common/Buttons/BaseButton";
import { CommonUsedCard } from "../../CommonComponents/Common";
import DynamicTable from "../../CommonComponents/Table/DynamicTable";
import {
  addNotificationAction,
  addWhatsappAccount,
  createWhatsappTemplateAction,
  getAllWhatsappAccountsAction,
} from "../../Store/Account/Account.action";

declare global {
  interface Window {
    FB: any;
  }
}
function Whatsapp() {
  const dispatch = useDispatch();
  const reducer = useSelector((state: any) => state);
  const {
    AccountReducer: { selectedAccount },
  } = reducer;

  const [state, setState] = useState<any>({
    businessData: [],
    selectedId: "",
    headerText: "",
    bodyText: "",
    footerText: "",
    type: "",
    templateName: "",
    selectedData: [],
  });
  const {
    businessData,
    selectedId,
    headerText,
    bodyText,
    footerText,
    type,
    templateName,
    selectedData,
  } = state;

  useEffect(() => {
    dispatch(updateCurrentPath("Integrations/Whatsapp", ""));
    const data = selectedAccount?.waba_business_ids;
    if (data?.length > 0) {
      const kl: any = [];
      data.forEach((d) => kl.push(`ids=${d}`));

      const init = async () => {
        const res: any = await dispatch(
          getAllWhatsappAccountsAction(kl.join("&"))
        );

        setState((prev) => ({
          ...prev,
          businessData: [...res.details],
        }));
      };
      init();
    }
  }, []);

  function launchWhatsAppSignup() {
    window.FB.login(
      function (response) {
        if (response.authResponse) {
          dispatch(addWhatsappAccount({ code: response.authResponse.code }));
        } else {
          console.log("User cancelled login or did not fully authorize.");
        }
      },
      {
        config_id: "925057419311402",
        response_type: "code",
        override_default_response_type: true,
        extras: {
          setup: {},
        },
      }
    );
  }

  const templateUse = (id) => {
    let found = businessData?.find((d) => d.id === id);
    setState((prev) => ({
      ...prev,
      selectedId: id,
      selectedData: found,
    }));
  };
  const onChange = (e) => {
    e.persist();
    setState((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const createTemplate = async () => {
    if (!selectedId) {
      dispatch(
        addNotificationAction("Please select Whatsapp account", "warning")
      );
      return;
    }
    const obj = {
      header: {
        header_format: "TEXT",
        text: `${headerText}{{1}}`,
        examples: ["Some text"],
      },
      body: {
        text: `${bodyText}{{1}}`,
        examples: [["Some text"]],
      },
      footer: {
        text: footerText,
      },
      category: type,
      language_code: "en_US",
      name: templateName,
    };

    await dispatch(createWhatsappTemplateAction(selectedId, obj));
  };

  return (
    <Box>
      <button
        onClick={launchWhatsAppSignup}
        style={{
          backgroundColor: "#1877f2",
          border: 0,
          borderRadius: "4px",
          color: "#fff",
          cursor: "pointer",
          fontFamily: "Helvetica, Arial, sans-serif",
          fontSize: "16px",
          fontWeight: "bold",
          height: "40px",
          padding: "0 24px",
        }}
      >
        Login with Facebook
      </button>

      <Box className="border my-2" sx={{ borderRadius: 2 }}>
        <DynamicTable
          columns={[
            {
              label: "Business Name",
              field: "name",
              styles: { py: 1.5 },
            },
            {
              label: "Phone Numbers",
              render: ({ phone_numbers }) => phone_numbers?.data?.length || 0,
            },

            {
              label: "Message Templates",
              render: ({ message_templates }) =>
                message_templates?.data?.length || 0,
            },

            {
              label: "Action",
              render: ({ id }) => (
                <BaseButton
                  title="Use"
                  handleClick={() => templateUse(id)}
                  styles={{ color: "34280FF" }}
                />
              ),
            },
          ]}
          data={businessData}
          rowCount={businessData?.length}
          noDataAvailableMessage="No Business Data Available"
        />
      </Box>
      <Box className="border my-3" sx={{ borderRadius: 2 }}>
        <DynamicTable
          columns={[
            {
              label: "Template Name",
              field: "name",
              styles: { py: 1.5 },
            },
            {
              label: "Category",
              field: "category",
            },

            {
              label: "Status",
              field: "status",
            },
            {
              label: "Language",
              field: "language",
            },
          ]}
          data={selectedData?.message_templates?.data}
          rowCount={selectedData?.message_templates?.data?.length}
          noDataAvailableMessage="No Message Templates Available"
        />
      </Box>

      <CommonUsedCard
        body={
          <>
            <select
              onChange={onChange}
              name="type"
              className="form-control m-1"
            >
              <option value={""} disabled selected hidden>
                Choose Category
              </option>
              <option value="MARKETING">Marketing</option>
              <option value="UTILITY">Utility</option>
            </select>

            <input
              placeholder="Template Name"
              onChange={onChange}
              className="form-control m-1"
              name="templateName"
            />
            <input
              placeholder="Header Text"
              onChange={onChange}
              className="form-control m-1"
              name="headerText"
            />
            <input
              placeholder="Body Text"
              onChange={onChange}
              className="form-control m-1"
              name="bodyText"
            />
            <input
              placeholder="Footer Text"
              onChange={onChange}
              className="form-control m-1"
              name="footerText"
            />
            <BaseButton
              variant="contained"
              title="Create Template"
              handleClick={createTemplate}
              styles={{ marginTop: 1 }}
            />
          </>
        }
        title={"Create Template"}
      />
    </Box>
  );
}

export default Whatsapp;
